var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"left-cover"}),_c('div',{staticClass:"right-cover"}),_c('div',{staticClass:"page-header"},[_c('screen-header')],1),_c('div',{staticClass:"page-content"},[_c('router-view')],1),_c('div',{staticClass:"page-footer"})])
}
var staticRenderFns = []

export { render, staticRenderFns }